import React from "react";

function ServiceInfo() {
  return (
    <section className=" text-pureWhite pt-10 md:pt-20">
      <h1 className="text-base md:text-4xl lg:text-5xl font-clashBold uppercase text-center">
        Embrace the Future of Mobility with Our Electric Vehicles
      </h1>
      <div className="bg-serviceDetails bg-no-repeat bg-cover bg-center px-8 py-12 rounded-3xl mt-4 md:mt-10">
        <div className="max-w-sm ml-auto bg-transparentLight border border-navyDark px-8 py-6 md:py-20 lg:py-24 rounded-2xl">
          <p>
            Our electric vehicles are designed to provide a sustainable,
            efficient, and comfortable driving experience. With cutting-edge
            technology, reliable performance, and zero-emission, our electric
            cars offer a smarter and cleaner way to travel. Whether you are
            commuting to work, running errands, or taking a road trip, our
            electric vehicles are the perfect choice for eco-conscious drivers
            who value comfort, style, and innovation.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ServiceInfo;
